import { render } from "./HHPatientDetails.vue?vue&type=template&id=7e1bb756"
import script from "./HHPatientDetails.ts?vue&type=script&lang=js&external"
export * from "./HHPatientDetails.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__